import FailureIcon from "../../Assets/images/Featured icon.png";

const FailureScreen = () => {
  return (
    <div className="mainScreen">
      <div className="innerScreen">
        <img className="imgStyle" src={FailureIcon} alt="Payment Failed" />
        <p className="headingStyle"> Payment Failed</p>
        <p className="textStyle">
          Unfortunately, your payment could not be processed at this time.
          Please check your card details, ensure you have sufficient funds or
          try again with a different payment method.
        </p>
      </div>
    </div>
  );
};

export default FailureScreen;
